import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { AbstractSections, DetailsSection, NewNDCRevisionNoticePage } from 'src/app/model/page/group/revision-notices/new-ndc-revision-notices-page';
import { NewRevisionNoticeXmlSection } from 'src/app/model/section/new-revision-notice-xml-section';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-new-ndc-revision-notice-page',
  templateUrl: './new-ndc-revision-notice-page.component.html',
  styleUrls: ['./new-ndc-revision-notice-page.component.scss']
})
export class NewNdcRevisionNoticePageComponent implements OnInit {
  @Input() pageTitle = '';

  newNDCRevisionNoticePage: NewNDCRevisionNoticePage = {} as NewNDCRevisionNoticePage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'product-update-notifications') {
        this.newNDCRevisionNoticePage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.pageTitle': this.pageTitle };

    this.newNDCRevisionNoticePage.productChangeNoticeSections = [];
    this.newNDCRevisionNoticePage.abstractSections = {} as AbstractSections;
    this.newNDCRevisionNoticePage.apiFlowSections = [];
    this.newNDCRevisionNoticePage.detailsXMLSections = {} as DetailsSection;
    this.newNDCRevisionNoticePage.xmlData = [];
    this.newNDCRevisionNoticePage.oneXmlData = {} as NewRevisionNoticeXmlSection;

    this.contentfulService.getRevisionNoticePageResponse(query).then((revisionNoticesPageEntries) => {
      // console.log('revisionNoticesPage', revisionNoticesPage);
      this.mapBanners(revisionNoticesPageEntries);
      this.sharedDataService.addSharedData(this.newNDCRevisionNoticePage.banner);
      this.mapHtmlTitle(revisionNoticesPageEntries);
      this.mapRevisionNoticePageEntries(revisionNoticesPageEntries);
    });
  }

  private mapBanners(revisionNoticesPageEntries: Entry<any>[]) {
    revisionNoticesPageEntries.forEach((entry) => {
      this.mapEntryToBanner(entry);
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['bannerImage'];
    this.newNDCRevisionNoticePage.banner = {
      title: entry.fields['bannerTitle'] as string,
      subTitle: entry.fields['bannerSubtitle'] as string,
      image: image.fields.file.url,
      lastUpdated: entry.fields['lastUpdatedDate'] as string,
      url: entry.fields['url'] as string
    };
  }

  private mapHtmlTitle(entry: Entry<any>[]) {
    this.newNDCRevisionNoticePage.htmlTitle = entry[0].fields['htmlTitle'] as string;
  }

  private mapRevisionNoticePageEntries(revisionNoticesPageEntries: Entry<any>[]) {
    (revisionNoticesPageEntries || []).forEach((entry) => {
      this.mapProductChangeNoteSections(entry);
      this.mapAbstractSections(entry);
      this.mapAPIFlow(entry);
      this.mapDetailsXMLSection(entry);
      this.mapTechnicalReferencesSection(entry);
    });
  }

  private mapProductChangeNoteSections(entry: Entry<any>) {
    let thead: any[] = [];
    let tbody: any[] = [];
    let releaseNotificationTable: any = entry.fields['releaseNotificationTable'];
    if (typeof releaseNotificationTable !== 'undefined') {
      releaseNotificationTable.content.forEach((data: any) => {
        if (data.nodeType == 'table') {
          data.content.forEach((tableRow: any) => {
            if (tableRow.nodeType === 'table-row') {
              tableRow.content.forEach((tableItem: any) => {
                if (tableItem.nodeType === 'table-header-cell') {
                  thead.push(tableItem.content[0].content[0].value);
                } else if (tableItem.nodeType === 'table-cell') {
                  tbody.push(tableItem.content[0].content[0].value);
                }
              });
            }
          });
        }
      });
      let constants: any = entry.fields['constants'];
      this.newNDCRevisionNoticePage.productChangeNoticeSections.push({
        title: constants?.ProductChangeNote,
        body: (entry.fields['releaseNotificationBody'] ? entry.fields['releaseNotificationBody'] : '') as string,
        group: '',
        order: 0,
        tHead: thead,
        tBody: tbody
      });
    }
  }

  private mapAbstractSections(entry: Entry<any>) {
    let abstract = entry.fields['abstractContent'] as string;
    if (typeof abstract !== 'undefined') {
      let constants: any = entry.fields['constants'];
      this.newNDCRevisionNoticePage.abstractSections = {
        abstractTitle: constants.Abstract,
        abstractBody: abstract
      };
    }
  }

  private mapAPIFlow(entry: Entry<any>) {
    let tBody: string[] = [];
    let affectedApiFlowContent: any = entry.fields['affectedApiFlowContent'];
    if (typeof affectedApiFlowContent !== 'undefined') {
      affectedApiFlowContent.split('\n').forEach((apiArrow: any) => {
        if (apiArrow !== '') {
          tBody.push(apiArrow);
        }
      });
      let constants: any = entry.fields['constants'];
      this.newNDCRevisionNoticePage.apiFlowSections.push({
        title: constants?.affectedAPIFlow,
        body: entry.fields['affectedApiFlowContent'] as string,
        bodyArrows: tBody,
        order: 0,
        group: ''
      });
    }
  }

  private mapDetailsXMLSection(entry: Entry<any>) {
    let detailsContent = entry.fields['detailsContent'] as string;
    if (typeof detailsContent !== 'undefined') {
      let constants: any = entry.fields['constants'];
      this.newNDCRevisionNoticePage.detailsXMLSections = {
        detailsTitle: constants?.Details,
        detailsBody: detailsContent
      };
    }
  }

  private mapTechnicalReferencesSection(entry: Entry<any>) {
    let xml: any = entry.fields['xml'];
    if (xml && xml.data !== null) {
      let constants: any = entry.fields['constants'];
      this.newNDCRevisionNoticePage.codeSampleTitle = constants.codeSamples;
      xml.content.forEach((element: any) => {
        let xmlTitle: string = element?.data?.target?.fields?.title.split('#').pop();
        let xmlData: string = element?.data?.target?.fields?.file.url;
        if (typeof xmlData !== 'undefined') {
          this.newNDCRevisionNoticePage.xmlData.push({
            title: constants.codeSamples,
            xmlTitle: xmlTitle,
            xmlData: xmlData
          });
        }
      });
    }
  }
}
